import { render, staticRenderFns } from "./ModalPrompt.vue?vue&type=template&id=4b53dc52&scoped=true"
import script from "./ModalPrompt.vue?vue&type=script&lang=js"
export * from "./ModalPrompt.vue?vue&type=script&lang=js"
import style0 from "./ModalPrompt.vue?vue&type=style&index=0&id=4b53dc52&prod&lang=less"
import style1 from "./ModalPrompt.vue?vue&type=style&index=1&id=4b53dc52&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b53dc52",
  null
  
)

export default component.exports